
import React, { useState } from 'react';
import './About.css';
import Logo from '../../assets/about-me.svg';
import { useTheme } from '../../context/ThemeContext';

const About = () => {
  const darkTheme = useTheme();

  const themeStyle = {
    backgroundColor: darkTheme ? 'rgb(56,68,77)' : 'rgb(252, 249, 242)',
    color: darkTheme ? '#ffffff' : 'rgb(56,68,77)',
    borderBottom: darkTheme ? '1px solid rgb(214,210,206)' : 'white',
    borderTop: darkTheme ? '1px solid rgb(214,210,206)' : 'white',
  };

  return (
    <section id='aboutme' className="about-container" style={themeStyle}>
      <div className="about-heading-container">
        <h2 className="about-heading">ABOUT ME</h2>
      </div>

      <div className="about-section">
        <div className="about-section_1">
          <p className="about-description justify-paragraph">
            I am a passionate Data Engineer currently working at Accenture, with a strong foundation in ETL workflows and cloud-based data platforms like Snowflake. My primary focus lies in designing, building, and maintaining scalable data pipelines that drive meaningful business insights.Over time, I’ve developed a deep interest in transforming raw data into structured, accessible, and high-performance datasets. I work extensively with SQL, Coalesce, and various data modeling tools to streamline processes and ensure data quality.
          </p>
          <p className="about-details justify-paragraph">
            In addition to Data Engineering, I have experience working in full-stack web development using the MERN stack, allowing me to approach problems with both backend and frontend perspectives. I’m committed to writing clean, efficient code and continuously evolving with emerging technologies. I thrive in fast-paced, collaborative environments and enjoy tackling complex data challenges to support impactful decision-making.
          </p>
        </div>

        <div className="logo-container">
          <img src={Logo} alt="About me illustration" className="logo" />
        </div>
      </div>
    </section>
  );
};

export default About;

